<div class="tw:p-4" data-test="nudger-history-drawer">
  <div class="tw:flex tw:items-center tw:mb-4">
    <h2 class="tw:text-lg tw:font-bold tw:flex-1">History: {{data.rule.name}}</h2>
    <button type="button" class="btn" (click)="close()" data-test="history-close">Close</button>
  </div>

  @if (loading) {
    <p>Loading…</p>
  }

  @if (error) {
    <div class="tw:p-3 tw:border tw:border-red-500 tw:bg-red-50 tw:text-red-900 tw:rounded" data-test="history-error">{{error}}</div>
  }

  @if (!loading && !error) {
    @for (row of rows; track $index) {
      <div class="tw:py-2 tw:border-b tw:border-gray-200" data-test="history-row">
        <div class="tw:text-sm">
          <strong><admin-email [value]="row.changedBy || 'unknown'" /></strong>
          <span class="tw:opacity-75"> · {{row.changedUtc | date:'dd/MM/yyyy HH:mm'}}</span>
        </div>
        @for (change of changes(row); track change.label) {
          <div class="tw:text-sm" data-test="history-change">
            <span class="tw:opacity-60">{{change.label}}:</span> {{change.before}} → {{change.after}}
          </div>
        } @empty {
          <div class="tw:text-sm tw:opacity-60">Saved with no change.</div>
        }
      </div>
    } @empty {
      <p class="tw:opacity-60" data-test="history-empty">No changes recorded yet.</p>
    }
  }
</div>
